export default "__VITE_ASSET__CIwZy1JL__"